import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from '../../components/Sidebar';
import AvailabilityContainer from './availability-container';
import './styles.css';

const CommunityAvailabilitySidebar = (props) => {
  const { visible, closeFunction, schoolId, hideVisits, hideFairs, onAppointmentClick, disableScheduleModal } = props;
  return (
    <Sidebar
      as="aside"
      visible={visible}
      animation="overlay"
      direction="right"
      width="very wide"
      onClose={closeFunction}
      styleName="sidebar"
    >
      {
        schoolId && (
        <AvailabilityContainer
          schoolId={schoolId}
          closeFunction={closeFunction}
          params={{ id: schoolId }}
          hideVisits={hideVisits}
          hideFairs={hideFairs}
          onAppointmentClick={onAppointmentClick}
          disableScheduleModal={disableScheduleModal}
        />
        )
}
    </Sidebar>
  );
};
CommunityAvailabilitySidebar.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeFunction: PropTypes.func.isRequired,
  schoolId: PropTypes.string,
  hideVisits: PropTypes.bool,
  hideFairs: PropTypes.bool,
  disableScheduleModal: PropTypes.bool,
  onAppointmentClick: PropTypes.func,
};

export default CommunityAvailabilitySidebar;
